import { Component } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';

@Component({
  selector: 'tonteppich-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent {
  public language: string;
  constructor(private transloco: TranslocoService) {
    if (localStorage.getItem('lang')) {
      this.language = localStorage.getItem('lang');
      this.transloco.setActiveLang(this.language);
    } else {
      localStorage.setItem('lang', 'de')
      this.language = 'de';
      this.transloco.setActiveLang(this.language);
    }
  }

  setActiveLang() {
    if (this.language === 'de') {
      this.transloco.setActiveLang('en');
      localStorage.setItem('lang', 'en')
      this.language = 'en';
    } else {
      this.transloco.setActiveLang('de');
      localStorage.setItem('lang', 'de')
      this.language = 'de';
    }
  }
}
